import { District } from "./types";

export async function queryDistricts(query: string): Promise<District[]> {
    let res = await fetch(`/api/v1/geo/districts?q=${encodeURIComponent(query)}`);
    let jason = await res.json()
    if (res.status !== 200) {
        throw new Error(`Error: ${res.status} ${jason.message}`);
    }

    let districts = jason.data.map((district: any) => {
        return new District(
            district.id,
            district.name,
            district.province,
            district.region,
        );
    });
    return districts;
}

export async function fetchDistrict(id: number): Promise<District> {
    let res = await fetch(`/api/v1/districts/${id}`);
    let jason = await res.json()

    if (res.status !== 200) {
        throw new Error(`Error: ${res.status} ${jason.message}`);
    }

    let district = jason.data.district;
    return new District(
        district.id,
        district.name,
        district.province,
        district.region,
    );
}
